import React from 'react'
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

function Template2Footer(props) {
  const { handleNextPrevClick, isShowBtnPrev, isShowBtnFinish, direction, handelExit, totalWrongQ, totalCorrectQ, totalSkipQ, examType, isVidSecShow } = props;
  const { t } = useTranslation();

  return (
    <footer className="footer bg-primary py-2 exam-footer">
      <div className="container-fluid">
        <div className={`d-flex flex-column-reverse flex-md-row gap-2 justify-content-between align-items-stretch ${direction === 'ltr' ? '' : 'flex-md-row-reverse'}`}>
          {!isVidSecShow ?
            <div className="exam-footer-actions">
              {isShowBtnPrev ?
                <Button color="outline-light" className="btn-label waves-effect waves-light" onClick={() => { handleNextPrevClick('prev') }}>
                  <i className={` ${direction === 'ltr' ? "las la-arrow-circle-left label-icon align-middle fs-24 me-2" : "las la-arrow-circle-right label-icon align-middle fs-24 ms-2"} `}></i>
                  {t('Previous')}
                </Button>
                : ''}
              {!isShowBtnFinish ? (
                <Button color="outline-light" className="btn-label waves-effect waves-light" onClick={() => { handleNextPrevClick('next') }}>
                  <i className={` ${direction === 'ltr' ? "las la-arrow-circle-right label-icon align-middle fs-24 ms-2" : "las la-arrow-circle-left label-icon align-middle fs-24 me-2"} `}></i>
                  {t('Next')}
                </Button>
              ) :
                <Button color="outline-light" className="btn-label waves-effect waves-light" onClick={() => { handelExit() }}>
                  <i className={` ${direction === 'ltr' ? "las la-times-circle label-icon align-middle fs-24 ms-2" : "las la-times-circle label-icon align-middle fs-24 me-2"} `}></i>
                  {t('Finish')}
                </Button>
              }
            </div>
            : ''}

          {examType == 2 ?
            <div className="exam-footer-stats">
              <span className="btn btn-outline-light waves-effect waves-light">WA : {totalWrongQ}</span>
              <button className="btn btn-outline-light waves-effect waves-light">CA : {totalCorrectQ}</button>
              <button className="btn btn-outline-light waves-effect waves-light">SA : {totalSkipQ}</button>
            </div>
            : ''}
        </div>
      </div>
    </footer>
  )
}

export default Template2Footer
